var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiPort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "320px",
    y: "248px",
    height: "320px",
    width: "248px",
    viewBox: "0 0 24.8 32",
    style: {
      enableBackground: "new 0 0 24.8 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t.st0 {\r\n\t\t\tfill: #405D88;\r\n\t\t}\r\n\r\n\t\t.st1 {\r\n\t\t\tfill: #FFFFFF;\r\n\t\t}\r\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.8,12.4C24.8,12.4,24.8,12.4,24.8,12.4C24.8,12.4,24.8,12.4,24.8,12.4V0H0v24.8h6.5l5.9,7.2l5.9-7.2h6.5 V12.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17,14c-0.7,1.6-2.1,2.7-3.9,3v-6.9h3.1V8.6h-3.1V6.3h-1.5v2.4H8.5v1.5h3.1V17c-1.7-0.3-3.2-1.4-3.9-3l-1.3,0.6 h0c1,2.3,3.2,3.9,5.9,3.9c2.7,0,4.9-1.6,5.9-3.9L17,14z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiPort);
export default __webpack_public_path__ + "static/media/ri-port.5f330d35f81c20d7c03c4ae763c316ce.svg";
export { ForwardRef as ReactComponent };